import * as React from 'react';
import logo from '../img/logo.png'
import Home from './Home';
import Compare from './Compare';
import { Redirect } from 'react-router-dom';
import global from '../global';

const navbar = {
    height: 60,
    background: "#4FAED2",
    color: "#fff",
    padding: "20px 20px"
}

const navbarBtn = {
    color: "#fff",
    fontWeight: 600
}

const PageNotFound = () => (
    <div style={{ marginTop: 250 }}>Sorry, page you entered not found !!!</div>
);

export default class MenuGuest extends React.Component<any, any> {
    public path: any

    constructor(props: any) {
        super(props)
    }

    componentWillMount() {
        if (this.props.location !== undefined) {
            this.path = this.props.location.pathname;
        }
    }

    page() {
        const path = this.path;
        if (path === "/") {
            return <Home />;
        } else if (path === "/compare" || path === "/compare/") {
            return <Compare />;
        } 
        return <PageNotFound />;
        
    }

    render() {
        var token = localStorage.getItem('token');
        if (this.path === "/admin" || this.path === "/admin/") 
            return <div></div>
        else if ((this.path == "/login" || this.path == "/login/") || token == null)
            return <Redirect to="/login" />    
        
        return <div style={{ height: window.innerHeight }}>
            <header className="navbar" style={navbar}>
                <section className="navbar-section">
                    <img src={logo} /> <b>LEMA UNESA &copy; 2017</b>
                </section>
                <section className="navbar-center">
                </section>
                <section className="navbar-section">
                    <a href="/" className="btn btn-link" style={navbarBtn}>Home</a>
                    <a href="/compare" className="btn btn-link" style={navbarBtn}>Compare</a>
                    <a href="#" onClick={() => {
                        global.removeSession();
                        localStorage.removeItem("token");
                        localStorage.removeItem("profile");
                    }} className="btn btn-link" style={navbarBtn}>Log Out</a>
                </section>
            </header>

            {this.page()}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/MenuGuest.tsx